import React from "react";
import { Routes, Route } from "react-router-dom";

import Hue from "./app";
/**
 * Represents the Hue application component.
 *
 * @returns {JSX.Element} The rendered Routes component with its children.
 */
export default function HueApp() {
  return (
    <Routes>
      <Route path="/" element={<Hue />} />
    </Routes>
  );
}
